export default __webpack_public_path__ + "static/media/033-map.269c1e2b.png";